import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { FormProvider, RHFTextField } from 'src/components';
import { Paths } from 'src/config';
import { useCreateTrainerMutation } from 'src/redux/services/TrainerServices';
import * as Yup from 'yup';

const defaultValues = {
  name: '',
  desc: '',
};

const TrainerCreateValidationSchema = Yup.object({
  name: Yup.string().required('نام اجباری می باشد'),
  desc: Yup.string(),
});

export const TrainerCreateForm = () => {
  const navigate = useNavigate();
  const [createTrainer, { isLoading }] = useCreateTrainerMutation();
  const methods = useForm({
    defaultValues,
    resolver: yupResolver(TrainerCreateValidationSchema),
  });
  const { handleSubmit } = methods;

  async function onSubmit(values) {
    try {
      const body = {
        name: values.name,
        desc: values.desc !== '' ? values.desc : undefined,
      };
      await createTrainer(body).unwrap();
      enqueueSnackbar(`مدرس ${values.name} ساخته شد`, { variant: 'success' });
      navigate(Paths.trainer.list.path);
    } catch (error) {
      console.log('TRAINER CREATE ERROR', error);
      enqueueSnackbar(`مدرس ${values.name} ساخته نشد`, { variant: 'error' });
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <RHFTextField name={'name'} label={'نام'} />
        </Grid>
        <Grid item xs={12}>
          <RHFTextField name={'desc'} label={'توضیحات'} multiline minRows={5} />
        </Grid>
        <Grid item>
          <Button variant="contained" disabled={isLoading} type="submit">
            {Paths.trainer.create.title}
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
